import React from 'react';
import { toast } from 'react-toastify';

const ComprobanteModal = ({
  show,
  onClose,
  modalTitle,
  modalContent,
  modalError,
  selectedCuota,
  handleConfirmarPagoPrepagado,
  loadingComprobante,
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-panel modal-panel-xl relative p-6">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-slate-500 transition hover:text-slate-700"
          title="Cerrar"
          disabled={loadingComprobante}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <h3 className="modal-title mb-4">{modalTitle}</h3>
        {loadingComprobante ? (
          <div className="flex justify-center items-center p-4">
            <div className="animate-spin h-8 w-8 border-4 border-red-600 border-t-transparent rounded-full"></div>
            <span className="ml-2 text-slate-700">Cargando comprobante...</span>
          </div>
        ) : modalError ? (
          <div className="rounded-xl border border-red-200 bg-red-50 p-4">
            <p className="font-medium text-red-800">{modalError}</p>
          </div>
        ) : (
          <div className="space-y-4">
            {modalContent.comprobanteUrl ? (
              <div>
                <h4 className="mb-2 text-sm font-medium text-slate-700">Comprobante de Pago</h4>
                <iframe
                  src={modalContent.comprobanteUrl}
                  title="Comprobante de Pago"
                  className="h-[70vh] w-full rounded-lg border border-slate-200"
                  onError={() => {
                    console.error('Error loading comprobante PDF:', modalContent.comprobanteUrl);
                    toast.error('No se pudo cargar el comprobante');
                  }}
                />
              </div>
            ) : (
              <div className="rounded-xl border border-yellow-200 bg-yellow-50 p-4">
                <p className="font-medium text-yellow-800">No hay comprobante de pago disponible.</p>
              </div>
            )}
          </div>
        )}
        {selectedCuota && selectedCuota.estado === 'prepagado' && !modalError && !loadingComprobante && (
          <div className="modal-actions border-t border-slate-200 pt-4">
            <button
              onClick={handleConfirmarPagoPrepagado}
              className="btn-modal-success"
              disabled={loadingComprobante}
            >
              Confirmar Pago
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ComprobanteModal;
